import script from "./CreateTicket.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateTicket.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__